class Hamburger {
	constructor() {
		this.$scope = $('.hamburger');

		if (this.$scope.length < 1) {
			return;
		}
		this.init();
	}

	init() {
		this.observer = new MutationObserver(mutations => {
			this.toggleHamburger(mutations[0].target, this.checkMutation(mutations));
		});

		this.$scope.each((e) => {
			this.observer.observe(this.$scope[e], {
				attributes: true,
				attributeFilter: ['aria-expanded']
			});
		});
	}

	checkMutation(mutations) {
		if (mutations.length > 0) {
			return $(mutations[0].target).attr('aria-expanded') == 'true';
		}

		return false;
	}

	toggleHamburger(target, expanded) {
		if (!expanded) {
			return $(target).removeClass('is-active');
		}

		return $(target).addClass('is-active');
	}
}

export default new Hamburger();
